<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        @if (modeService.isIosMode()) {
        <div>Zurück</div>
        } @if (!modeService.isIosMode()) {
        <div>
          <ion-icon
            name="arrow-back-outline"
            slot="icon-only"
            size="medium"
          ></ion-icon>
        </div>
        }
      </ion-button>
    </ion-buttons>
    <ion-title>Rechnungszeile</ion-title>
    <ion-buttons slot="end">
      <ion-button
        (click)="save()"
        [disabled]="!invoiceItemForm.valid"
        [strong]="true"
        >Speichern</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form
    [formGroup]="invoiceItemForm"
    class="bg-iosbackground dark:bg-transparent pt-5"
  >
    <ion-list>
      <ion-item lines="full" button (click)="selectProduct()" detail="true">
        <ion-note slot="start">
        <ion-icon
          color="primary"
          name="cube-outline"
          class="-mt-1 text-lg"
        ></ion-icon>
      </ion-note>
        <ion-label
          >Produkt auswählen</ion-label
        >
      </ion-item>
    </ion-list>
    <ion-list class="mt-5">
      <ion-item>
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="document-text-outline"
            class="text-lg -mt-1"
          ></ion-icon>
        </ion-note>
        <ion-input formControlName="name" placeholder="Leistung"></ion-input>
      </ion-item>
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon color="primary" class="text-lg"></ion-icon>
        </ion-note>
        <ion-input formControlName="description" placeholder="Beschreibung"></ion-input>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item-divider>
        <ion-label>Übersicht</ion-label>
      </ion-item-divider>
      <ion-row>
        <ion-col>
          <ion-item lines="full">
            <ion-note slot="start">
              <ion-icon
                color="primary"
                name="pricetag-outline"
                class="text-lg -mt-1"
              ></ion-icon>
            </ion-note>
            <ion-input
              formControlName="amount"
              type="number"
              (input)="updatePrize()"
              placeholder="1"
              label="Anzahl"
            ></ion-input>
          </ion-item>
        </ion-col>
        <ion-col>
          <ion-item lines="full">
            <ion-select
              label="Einheit"
              formControlName="unit"
              okText="Festlegen"
              cancelText="Abbrechen"
            >
              <ion-select-option value="h">h</ion-select-option>
              <ion-select-option value="min">min</ion-select-option>
              <ion-select-option value="Stk">Stk.</ion-select-option>
              <ion-select-option value="Lektionen">
                Lektion(en)</ion-select-option
              >
            </ion-select>
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon color="primary" class="text-lg -mt-1"></ion-icon>
        </ion-note>
        <ion-input
          label="CHF "
          type="number"
          (input)="updatePrize()"
          formControlName="amount_prize"
          placeholder="Einzelpreis"
        ></ion-input>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="calendar-outline"
            class="text-lg -mt-1"
          ></ion-icon>
        </ion-note>
        <ion-input
          label="Datum"
          formControlName="date"
          placeholder="Datum"
          type="date"
        ></ion-input>
      </ion-item>
    </ion-list>
    @if (invoiceItemForm.value.unit === 'Lektionen' && !invoiceItemForm.value.subscription_id) {
      <ion-list class="mt-5 mb-5">
        <ion-item>
          <ion-note slot="start">
            <ion-icon
              color="primary"
              name="help-circle-outline"
              class="text-lg -mt-1"
            ></ion-icon>
          </ion-note>
          <ion-toggle formControlName="subscription_payment" helperText="Kann mit Lektionen aus einem Abo-Vertrag bezahlt werden">
            <ion-label>Abo-Zahlung möglich</ion-label>
            <ion-note color="medium" class="text-xs">Kann mit Lektionen aus Abos bezahlt werden</ion-note>
          </ion-toggle
          >
        </ion-item>
      </ion-list>
    }
    <ion-item-divider>
      <ion-label>Gesamtpreis</ion-label>
    </ion-item-divider>
    <ion-list lines="full">
      <ion-item>
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="cash-outline"
            class="text-lg -mt-1"
          ></ion-icon>
        </ion-note>
        <ion-input
          formControlName="prize"
          type="number"
          (input)="updateAmountPrize()"
          label="CHF "
        ></ion-input>
      </ion-item>
    </ion-list>
  </form>
  <div class="h-8"></div>
</ion-content>
